export function markerSpread(values, minN) {
    const xs = Object.values(values)
        .filter((g) => g.purchases >= minN && typeof g.answer.roas3 === 'number')
        .map((g) => g.answer.roas3);
    if (xs.length === 0)
        return null;
    const min = Math.min(...xs);
    const max = Math.max(...xs);
    return { min, max, width: max - min };
}
/** По ширине разброса, убывание; без разброса и недоступные — в конце (порядок ответа). */
export function rankMarkers(markers, minN) {
    const rows = Object.entries(markers).map(([key, marker], i) => ({
        key,
        marker,
        i,
        spread: marker.available ? markerSpread(marker.values, minN) : null,
    }));
    rows.sort((a, b) => {
        if (a.spread && b.spread)
            return b.spread.width - a.spread.width || a.i - b.i;
        if (a.spread)
            return -1;
        if (b.spread)
            return 1;
        return a.i - b.i;
    });
    return rows.map(({ key, marker, spread }) => ({ key, marker, spread }));
}
//# sourceMappingURL=spread.js.map